/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  AddCountryPlugin,
  IAddCountryPluginMethods,
  AddGroupPlugin,
  IAddGroupMethods,
  AppCardListPlugin,
  IAppCardListMethods,
  ErrorPayoutPlugin,
  IErrorPayoutPluginMethods,
  HeaderPayoutPlugin,
  IHeaderPayoutPluginMethods,
  LoadingPayoutPlugin,
  ILoadingPayoutPluginMethods,
  SettingsPayoutPlugin,
  ISettingsPayoutPluginMethods,
  StaticPagePayoutPlugin,
  IStaticPagePayoutPluginMethods,
} from './plugins';
import { IappCardListPluginMethods } from '@/pages/HoldersDetailPage/services/plugins';

export type TAgent = IAddCountryPluginMethods &
  IAddGroupMethods &
  IappCardListPluginMethods &
  IErrorPayoutPluginMethods &
  IHeaderPayoutPluginMethods &
  ILoadingPayoutPluginMethods &
  ISettingsPayoutPluginMethods &
  IStaticPagePayoutPluginMethods;
const getPlugins = () => {
  return [
    new StaticPagePayoutPlugin(),
    new ErrorPayoutPlugin(),
    new LoadingPayoutPlugin(),
    //Business logic plugins !
    new AddCountryPlugin(),
    new AddGroupPlugin(),
    new AppCardListPlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
